// importing components
import { Button, Col, Row } from "antd";

// importing styles
import styles from "./FrequentlyBoughtTogether.module.scss";

// importing images
import plusIcon from "./images/plus_icon.svg";

const FrequentlyBoughtTogether = ({ products }) => {
  return (
    <div className={styles.FrequentlyBoughtTogether}>
      <h2 className={styles.title}>Frequently Bought Together</h2>
      <Row gutter={[16, 16]}>
        <Col lg={5}>{/* <ProductCard product={products[0]} /> */}</Col>
        <div className={styles.plusContainer}>
          <img height={20} src={plusIcon} alt="plus" />
        </div>
        <Col lg={5}>{/* <ProductCard product={products[1]} /> */}</Col>
        <div className={styles.plusContainer}>
          <img height={20} src={plusIcon} alt="plus" />
        </div>
        <Col lg={5}>{/* <ProductCard product={products[2]} /> */}</Col>

        <Col lg={3}>
          <div className={styles.cartContainer}>
            <div
              style={{
                display: "flex",
                gap: 10,
                marginBottom: 10,
              }}
            >
              <strong>Total Price</strong>
              <div>1.27€</div>
            </div>
            <Button type="primary">Add To Cart</Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FrequentlyBoughtTogether;
